var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-expand-transition',{attrs:{"duration":150}},[(_vm.labelExists)?_c('v-alert',{staticClass:"mb-3",attrs:{"type":"warning","rounded":"","dense":"","text":"","outlined":"","color":"warningAnnouncement","icon":"mdi-alert-outline"}},[_c('strong',[_vm._v(_vm._s(_vm.$t("labelNameExistsWarning")))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }